import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FileUploadAwareJsonWriterClass;
function FileUploadAwareJsonWriter() {
  if (FileUploadAwareJsonWriterClass === VOID) {
    class $ {
      constructor(wrappedWriter) {
        this.s47_1 = wrappedWriter;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.t47_1 = LinkedHashMap().gc();
      }
      u47() {
        return this.t47_1;
      }
      u40() {
        // Inline function 'kotlin.apply' call
        this.s47_1.u40();
        return this;
      }
      v40() {
        // Inline function 'kotlin.apply' call
        this.s47_1.v40();
        return this;
      }
      p40() {
        // Inline function 'kotlin.apply' call
        this.s47_1.p40();
        return this;
      }
      q40() {
        // Inline function 'kotlin.apply' call
        this.s47_1.q40();
        return this;
      }
      r47(name) {
        // Inline function 'kotlin.apply' call
        this.s47_1.r47(name);
        return this;
      }
      b41(value) {
        // Inline function 'kotlin.apply' call
        this.s47_1.b41(value);
        return this;
      }
      l41(value) {
        // Inline function 'kotlin.apply' call
        this.s47_1.l41(value);
        return this;
      }
      g41(value) {
        // Inline function 'kotlin.apply' call
        this.s47_1.g41(value);
        return this;
      }
      d41(value) {
        // Inline function 'kotlin.apply' call
        this.s47_1.d41(value);
        return this;
      }
      j41(value) {
        // Inline function 'kotlin.apply' call
        this.s47_1.j41(value);
        return this;
      }
      h4a(value) {
        // Inline function 'kotlin.apply' call
        this.s47_1.h4a(value);
        return this;
      }
      q41(value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.t47_1;
        // Inline function 'kotlin.collections.set' call
        var key = this.s47_1.w49();
        tmp0.c5(key, value);
        this.s47_1.u3z();
        return this;
      }
      u3z() {
        // Inline function 'kotlin.apply' call
        this.s47_1.u3z();
        return this;
      }
      w49() {
        return this.s47_1.w49();
      }
      q6() {
        this.s47_1.q6();
      }
    }
    initMetadataForClass($, 'FileUploadAwareJsonWriter');
    FileUploadAwareJsonWriterClass = $;
  }
  return FileUploadAwareJsonWriterClass;
}
//region block: exports
export {
  FileUploadAwareJsonWriter as FileUploadAwareJsonWriter1mx337tg0y9oj,
};
//endregion

//# sourceMappingURL=FileUploadAwareJsonWriter.mjs.map
